<!--
  --
  -- v-card 用のエラー表示コンポーネント
  --
  -->
<template>
  <div v-if="messages.length > 0" class="px-4">
    <c-helper-text error :messages="messages"/>
  </div>
</template>

<script>
import CHelperText from './CHelperText'

export default {
  name: 'CCardErrors',
  components: {
    CHelperText
  },

  props: {
    /**
     * エラー文字列
     */
    errors: {
      type: [Array, String],
      default: ''
    }
  },
  computed: {
    messages () {
      if (Array.isArray(this.errors)) {
        return this.errors
      } else if (!this.errors) {
        return []
      } else {
        return [this.errors]
      }
    }
  }
}
</script>
